import { render, staticRenderFns } from "./StudentLetters.vue?vue&type=template&id=250780c0&"
import script from "./StudentLetters.vue?vue&type=script&lang=js&"
export * from "./StudentLetters.vue?vue&type=script&lang=js&"
import style0 from "./StudentLetters.vue?vue&type=style&index=0&id=250780c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports